/* global Symbol */

// Note: this module depends on src/component/global/polyfill being loaded

// Third-party imports
import $ from 'jquery';
import 'slider-pro';

// Local imports
import * as cardtemplate from './cardtemplate.js';
import * as select from './select.js';

// export const slider_id_css = '.sponsorshipSlider';
export const slider_id_css = '#spshhome-slider';

export const SliderEnd = {
    HEAD: Symbol('head'),
    TAIL: Symbol('tail'),
};

export function initialize() {
    // Note: each slide is 576 px high and 400 px wide
    let options = {
        width: 410,
        height: 600,
        autoHeight: true,
        loop: false,
        autoplay: false,
        arrows: true,
        buttons: false,
        fadeArrows: false,
        visibleSize: 1250,
        slideDistance: 20,
        autoSlideSize: true,
        autoScaleLayers: true,
        keyboard: true,
        keyboardOnlyOnFocus: true,

        breakpoints: {
            1250: {
                visibleSize: 420,
            },
        },
    };
    $(slider_id_css).sliderPro(options);

    init_drag_state_data();
}

function init_drag_state_data() {
    let threshold = 5;
    let startX = 0;
    let deltaX = 0;
    let sliderID = '#spshhome-slider';
    $(sliderID)
        .mousedown(function(event) {
            $(sliderID).attr('data-drag-state', 'down');
            startX = event.pageX;
            $(this).mousemove(function(event) {
                deltaX = Math.abs(startX - event.pageX);
                if (
                    deltaX > threshold &&
                    $(this).attr('data-drag-state') === 'down'
                ) {
                    $(this).attr('data-drag-state', 'dragging');
                }
            });
        })
        .mouseup(function() {
            $(this).unbind('mousemove');
            setTimeout(() => {
                if ($(this).attr('data-drag-state') === 'dragging') {
                    $(this).attr('data-drag-state', '');
                }
            }, 500);
        });
}

// Go to the middle slide if this add was on init
export function initial_position(shared) {
    let slider_node = $(slider_id_css);
    let pro = slider_node.data('sliderPro');
    let slider_size = pro.slides.length;

    // Approximately the middle slide; will only be the middle if
    // there is an odd number of slides
    let middle_index = Math.floor(slider_size / 2);
    shared.add_slides = false;
    slider_node.sliderPro('gotoSlide', middle_index);
    //Call functions to set focus to only visible slides
    handle_focus(middle_index);
    trackFocusableElements();
}

export function clearSlides(shared) {
    let pro = $(slider_id_css).data('sliderPro');
    if (pro.slides.length === 0) {
        return;
    }
    shared.add_slides = false;
    pro.gotoSlide(0);
    let slider = $(slider_id_css);
    let slider_node = slider[0].querySelector('.sp-slides');
    while (slider_node.firstChild) {
        slider_node.removeChild(slider_node.firstChild);
    }
    pro = $(slider_id_css).data('sliderPro');
}

export function clearSlides2() {
    let pro = $(slider_id_css).data('sliderPro');
    pro.destroy();

    initialize();
}

function new_slide(global, slide) {
    let html = cardtemplate.build(global, slide);

    // Wrap the html in divs required by slider-pro
    html = `
        <div class="sp-slide sp-padding">
            <div class="sp-layer sp-static sponsorshipCard-slide-flex-container" data-position="topLeft"
                    data-width="400" data-height="100%">
                ${html}
            </div>
        </div>
    `;
    let parser = new DOMParser();
    let nodes = parser.parseFromString(html, 'text/html').body.firstChild;
    return nodes;
}

// shared is an object that contains the following attributes:
//
// * global -- the global object (window when in a browser)
//
// * tocart_callbacks -- callbacks needed to dynamically create the tocart form
//   of any sponsorship page (eg sponsorship home, events app). This form is
//   responsible for adding a sponsorship to a donor's cart.
//
// * page_data -- object containing the following attributes:
//
//    - midpage_cta_datalayer_suffix -- string to suffix event label stored in
//    the datalayer
function add_slides(shared, slides, addfunc) {
    if (slides.length === 0) {
        return 0;
    }
    let global = shared.global;
    let slider = $(slider_id_css);
    let parent_node = slider[0].querySelector('.sp-slides');
    let num_added = 0;

    slides.forEach(slide => {
        let nodes = new_slide(global, slide);
        let added_slide = addfunc(parent_node, nodes);
        select.init_slide(shared, added_slide);
        num_added += 1;
    });

    slider.sliderPro('update');
    return num_added;
}

// shared is an object that contains the following attributes:
//
// * global -- the global object (window when in a browser)
//
// * tocart_callbacks -- callbacks needed to dynamically create the tocart form
//   of any sponsorship page (eg sponsorship home, events app). This form is
//   responsible for adding a sponsorship to a donor's cart.
//
// * page_data -- object containing the following attributes:
//
//    - midpage_cta_datalayer_suffix -- string to suffix event label stored in
//    the datalayer
export function addSlides(shared, slides) {
    let ret = add_slides(shared, slides, (parent_node, nodes) => {
        return parent_node.appendChild(nodes);
    });
    return ret;
}

export function insertSlides(shared, slides) {
    let ret = add_slides(shared, slides, (parent_node, nodes) => {
        // Remove data-index attribute of all current slides
        // This is to force the slider to re-create all slides
        let slider_slides = parent_node.querySelectorAll('.sp-slide');
        let index_name = 'data-index';
        for (let s of slider_slides) {
            s.removeAttribute(index_name);
            // TODO
            // let curval = parseInt(s.getAttribute(index_name));
            // s.setAttribute(index_name, `${curval + num_slides}`);
        }

        let first_slide = parent_node.querySelector('.sp-slide');
        return parent_node.insertBefore(nodes, first_slide);
    });
    return ret;
}

export function shouldLoadMore(shared, cb) {
    let slider = $(slider_id_css);
    // Change slider opacity to 1 if wait_for_slider value is true
    slider.on('gotoSlideComplete', () => {
        if (!shared.wait_for_slider) {
            return;
        }
        slider.fadeTo('fast', 1);
        $('.spinner').hide();
        shared.wait_for_slider = false;
    });

    slider.on('gotoSlide', event => {
        if (!shared.add_slides) {
            shared.add_slides = true;
            return;
        }

        let slider_size = slider.data('sliderPro').slides.length;
        let cur_index = event.index;
        let prev_index = event.previousIndex;

        // This will run the callback function cb if switch to any slide from
        // the third last to the last slide. This is done instead of being on
        // second last or on the last slide to ensure the right-side arrow
        // remains visible -- if adding more slides on the second last or last
        // slide, the right-side arrow does not appear.
        //
        // Note: the slider uses 0-indexing
        let loader_slide_tail = slider_size - 3;
        let loader_slide_head = 2;

        // Load to the end
        if (cur_index >= loader_slide_tail && prev_index < loader_slide_tail) {
            cb(SliderEnd.TAIL);
        } else if (
            cur_index <= loader_slide_head &&
            prev_index > loader_slide_head
        ) {
            cb(SliderEnd.HEAD);
        }
    });

    return;
}

export function shouldClear() {
    let loadingSlides = $('.sponsorshipSlider .sponsorshipCard--loading');
    return Boolean(loadingSlides.length);
}

function trackFocusableElements() {
    let arrow_buttons = global.document.querySelectorAll('.sp-arrow');
    arrow_buttons.forEach(button => {
        button.addEventListener('click', function() {
            let selected_slide = global.document.querySelector('.sp-selected');
            let selected_index = selected_slide.getAttribute('data-index');
            handle_focus(selected_index);
        });

        button.addEventListener('keydown', function(e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                button.click();
            }
        });
    });
    global.document.addEventListener('keydown', function(e) {
        if (e.keyCode === 37 || e.keyCode === 39) {
            let selected_slide = global.document.querySelector('.sp-selected');
            let selected_index = selected_slide.getAttribute('data-index');
            handle_focus(selected_index);
        }
    });
}
//Function to set focus to only visible slides
function handle_focus(index) {
    let slide_container = global.document.querySelector('.sp-slides');
    let all_focusable_els = slide_container.querySelectorAll(
        '.tocart-btn, .sponsorshipCard-link'
    );
    let visible_slide = slide_container.querySelector(
        `[data-index="${index}"]`
    );
    let visible_slides = slide_container.querySelectorAll(
        `[data-index="${index - 1}"],
         [data-index="${index}"],
         [data-index="${Number(index) + 1}"]`
    );
    let visible_focusable_els = [];
    let break_point = 1250;
    //Make all buttons and links within slides unfocusable
    all_focusable_els.forEach(el => {
        el.setAttribute('tabindex', '-1');
    });
    //Only visible buttons and links can get focus
    if (window.innerWidth <= break_point) {
        visible_focusable_els = visible_slide.querySelectorAll(
            '.tocart-btn, .sponsorshipCard-link'
        );
    } else {
        visible_slides.forEach(slide => {
            let focusable_els = slide.querySelectorAll(
                '.tocart-btn, .sponsorshipCard-link'
            );
            focusable_els.forEach(el => {
                visible_focusable_els.push(el);
            });
        });
    }
    visible_focusable_els.forEach(el => {
        el.setAttribute('tabindex', '0');
    });

    // Set arrows to be focusable
    let prev_arrow = global.document.querySelector('.sp-previous-arrow');
    let next_arrow = global.document.querySelector('.sp-next-arrow');
    prev_arrow.setAttribute('tabindex', '0');
    next_arrow.setAttribute('tabindex', '0');
    prev_arrow.setAttribute('role', 'button');
    next_arrow.setAttribute('role', 'button');
}
